"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModificationInfo = exports.ContextModificationInfo = exports.ModificationAction = void 0;
const tslib_1 = require("tslib");
require("babel-polyfill");
const Instance_1 = require("./Instance");
var ModificationAction;
(function (ModificationAction) {
    ModificationAction[ModificationAction["Unknown"] = -1] = "Unknown";
    ModificationAction[ModificationAction["Object"] = 0] = "Object";
    ModificationAction[ModificationAction["Link"] = 1] = "Link";
})(ModificationAction = exports.ModificationAction || (exports.ModificationAction = {}));
class ContextModificationInfo {
    // Methods
    constructor() {
        // Properties
        this.action = ModificationAction.Unknown;
        this.relation = undefined;
        this.parent = undefined;
        this.instances = undefined;
    }
    static fromJSON(json, virtualFields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let conModInfoReturn = new ContextModificationInfo();
            if (typeof json["action"] !== "undefined")
                conModInfoReturn.action = json["action"];
            if (typeof json["relation"] !== "undefined")
                conModInfoReturn.relation = json["relation"];
            if (json["parent"])
                conModInfoReturn.parent = yield Instance_1.Instance.fromJSON(json["parent"], virtualFields);
            if (json["instances"])
                conModInfoReturn.instances = yield Instance_1.Instance.fromJSONArray(json["instances"], virtualFields);
            return conModInfoReturn;
        });
    }
}
exports.ContextModificationInfo = ContextModificationInfo;
class ModificationInfo {
    // Methods
    constructor() {
        // Properties
        this.fullRefreshNecessary = false;
    }
    static fromJSON(json, virtualFields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let modInfoReturn = new ModificationInfo();
            if (json["fullRefreshNecessary"])
                modInfoReturn.fullRefreshNecessary = json["fullRefreshNecessary"];
            if (json["modifiedInstances"])
                modInfoReturn.modifiedInstances = yield Instance_1.Instance.fromJSONArray(json["modifiedInstances"], virtualFields);
            if (json["readInstances"])
                modInfoReturn.readInstances = yield Instance_1.Instance.fromJSONArray(json["readInstances"], virtualFields);
            if (json["deletions"])
                modInfoReturn.deletions = yield ContextModificationInfo.fromJSON(json["deletions"], virtualFields);
            if (json["new"])
                modInfoReturn.new = yield ContextModificationInfo.fromJSON(json["new"], virtualFields);
            return modInfoReturn;
        });
    }
}
exports.ModificationInfo = ModificationInfo;
